import { render } from "./Rentabilite.vue?vue&type=template&id=def117aa&scoped=true"
import script from "./Rentabilite.vue?vue&type=script&lang=js"
export * from "./Rentabilite.vue?vue&type=script&lang=js"

import "./Rentabilite.vue?vue&type=style&index=0&id=def117aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-def117aa"]])

export default __exports__